import React, {FC, useCallback, useState, useEffect} from "react";
import {
    AdequacyTypeID, ComponentTypeID,
    IAdequacy,
    IControlMeasureAdequacy,

    IProjectFailureMode
} from "../types/types";



import {
    Box,
    Chip,
    Collapse,
    IconButton,
    Table, TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Tooltip
} from "@material-ui/core";
import FailureModesControlMeasureSelect from "./failure_mode_control_measure";
import ControlTypeSelection from "./control_type";
import AdequacySelection from "./adequacy_selection";
import {WarningChip} from "./reasonably_practicable_tests";
import Comments from "./comments";

import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Investigations from "./investigations";
import {yellow} from "@material-ui/core/colors";
import {  useTask } from '../stateManagement/context';



interface IControlMeasureAdequacyProps {
    control_measure_adequacy: IControlMeasureAdequacy
    project_failure_mode:IProjectFailureMode
    updateControlMeasuresAdequacy: (controlMeasureAssessment: IControlMeasureAdequacy) => void;
    adequacies: IAdequacy[] 
}

interface IControlAssessment {
    level: number,
    name: string
}



export const ControlAssessment = (control_measure_adequacy: IControlMeasureAdequacy, name?:string) => {

    let op = control_measure_adequacy.improvement_adequacy
    if (!op)
         return WarningChip(name?name:"undefined")

    let level = op.level

    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    let alpha = 1
    let label = op.name

    if (level === 1) {

        bcolor = "rgba(251,84,81," + alpha + ")";
        color = "rgb(104,4,0)";
    }
    if (level === 2) {
        bcolor = "rgba(252,236,166," + alpha + ")";
        color = "rgb(152,96,34)";
    }
    if (level === 3) {
        bcolor = "rgba(206,238,208," + alpha + ")";
        color = "rgb(48,104,33)";
    }
    if (level > 3) {
        bcolor = "rgba(206,238,208," + alpha + ")";
        color = "rgb(48,104,33)";
    }

    return (
        <Tooltip title={label}>
            <Chip
                size="small"
                label={name? name : label}
                color="primary"
                style={{backgroundColor: bcolor, color: color}}
            />
        </Tooltip>
    )
}


const ControlMeasureAdequacy: FC<IControlMeasureAdequacyProps> = ({control_measure_adequacy,
                                                                      project_failure_mode,
                                                                      adequacies,
                                                                  updateControlMeasuresAdequacy}) => {

    const [currentControlMeasureAdequacy, setCurrentControlMeasureAdequacy] = useState<IControlMeasureAdequacy>(control_measure_adequacy);
    const [justification, setJustification] = useState<string>(control_measure_adequacy.comment as string);
    const [open, setOpen] = useState(false);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    let tasks = useTask()


    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])


    const graph_data = [
        ["Weak", "Weak", "Very Weak", "Very Weak"],
        ["Moderate", "Weak", "Weak", "Very Weak"],
        ["Strong", "Moderate", "Weak", "Weak"],
        ["Strong", "Strong", "Moderate", "Weak"]]

    const updateAdequacies = <T,>(obj: T,
                                  selected_id: number,
                                  key:keyof T,
                                  setObj:(obj:T) => void) : T => {
        let c = {...obj} as T;
        (c as any)[key] = selected_id
        setObj(c)
        return c
    }

    const updateExisting = useCallback((selected_id: number ) => {
        let c = updateAdequacies<IControlMeasureAdequacy>(
            currentControlMeasureAdequacy,
            selected_id,
            "existing_adequacy_id",
            setCurrentControlMeasureAdequacy)
        updateControlMeasuresAdequacy(c)

    }, [setCurrentControlMeasureAdequacy, currentControlMeasureAdequacy]);

    const updateAdditional = useCallback((selected_id: number ) => {
        let c = updateAdequacies<IControlMeasureAdequacy>(
            currentControlMeasureAdequacy,
            selected_id,
            "additional_adequacy_id",
            setCurrentControlMeasureAdequacy)

        updateControlMeasuresAdequacy(c)

    }, [setCurrentControlMeasureAdequacy, currentControlMeasureAdequacy]);



    return (
        <>
            <TableRow>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>{project_failure_mode.failure_mode?.name}</TableCell>
                <TableCell><AdequacySelection adequacies={adequacies}
                                              type_id={AdequacyTypeID.ExistingControlMeasureHazard}
                                              initial_value={(currentControlMeasureAdequacy.existing_adequacy_id || 0).toString()}
                                              updateCallback={updateExisting}/></TableCell>
                <TableCell><AdequacySelection adequacies={adequacies}
                                              type_id={AdequacyTypeID.AdditionalControlMeasureHazard}
                                              initial_value={(currentControlMeasureAdequacy.additional_adequacy_id || 0).toString()}
                                              updateCallback={updateAdditional}/></TableCell>
                <TableCell>{ControlAssessment(control_measure_adequacy)}</TableCell>
                <TableCell>
                    <TextField
                        style ={{width: '100%'}}
                        inputProps={{ style: { fontSize: "11pt" } }}
                        id="standard-text"
                        value={justification}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        disabled={!write_access}
                        multiline={true}
                        onChange={(event) => {
                            let value = event.target.value
                            setJustification(value)
                            let c = {...currentControlMeasureAdequacy}
                            c.comment = value
                            setCurrentControlMeasureAdequacy(c)
                        }

                        }
                        onBlur={(event) => {
                            let value = event.target.value
                            setJustification(value)
                            let c = {...currentControlMeasureAdequacy}
                            c.comment = value
                            setCurrentControlMeasureAdequacy(c)
                            updateControlMeasuresAdequacy(c)
                        }

                        }

                    />
                </TableCell>
                <TableCell>{project_failure_mode.id && <Comments parent_uuid={project_failure_mode.id} type_id={ComponentTypeID.ControlMeasureAdequacy}/>}</TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }}colSpan={1}/>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                {adequacies.filter( a => a.type_id === AdequacyTypeID.ExistingControlMeasureHazard).reverse().map(
                                    (ad) => {
                                    return (
                                        <TableCell> {ad.name} </TableCell>
                                    ) }
                                )}
                                </TableRow>


                            </TableHead>

                            <TableBody>
                                {adequacies.filter( a => a.type_id === AdequacyTypeID.AdditionalControlMeasureHazard).reverse().map(
                                    (ad, index) => {
                                                return (
                                                    <TableRow>
                                                        <TableCell>{ad.name}  </TableCell>

                                                        {graph_data[index].map( (e, index_i) => {
                                                            let found = false
                                                            let found1 = false
                                                            if (ad.id ===  control_measure_adequacy.additional_adequacy_id) {
                                                                found = true
                                                            }
                                                            let ex = adequacies.filter( a => a.type_id === AdequacyTypeID.ExistingControlMeasureHazard).reverse()[index_i]
                                                            if (ex.id === control_measure_adequacy.existing_adequacy_id) {
                                                                found1 = true
                                                            }
                                                            let style = {}
                                                            if (found && found1) {
                                                                style = ({ ...style, fontWeight:  "bold",
                                                                    outline: "4px solid black",
                                                                    outlineOffset: "-4px"})
                                                            }

                                                            if (e === "Weak" || e === "Very Weak") {
                                                                style = ({ ...style,
                                                                    backgroundColor:  "rgb(206,238,208)",
                                                                    color: "rgb(48,104,33)"
                                                                })
                                                            }
                                                            if (e === "Moderate") {
                                                                style = ({ ...style,
                                                                    backgroundColor:  "rgb(252,236,166)",
                                                                    color: "rgb(152,96,34)"
                                                                })
                                                            }
                                                            if (e === "Strong") {
                                                                style = ({ ...style,
                                                                    backgroundColor:  "rgb(251,84,81)",
                                                                    color: "rgb(104,4,0)"
                                                                })
                                                            }

                                                        return <TableCell style={style}>



                                                            {e}
                                                            </TableCell>
                                                    })}
                                                    </TableRow>
                                        )}
                                )}
                            </TableBody>

                        </Table>

                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

export default ControlMeasureAdequacy;
